import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { Box } from '@mui/material';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { setBuAction } from '../redux/profile/profileActions';
import COLORS from '../styles/COLORS';


const BuSelect = (props) => {
  const dispatch = useDispatch()
  const profileState = useSelector((state) => state.profile);
  const businessUnitArr = [profileState.appAcc[0].business_unit, ...(profileState.appAcc[0].secondary_office || [])]
  const [anchorEl, setAnchorEl] = useState(null);
  const isBuSelectOpen = Boolean(anchorEl)
  const BuSelectId = isBuSelectOpen ? 'simple-popover' : undefined

  const handleBuClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleBuClose = () => {
    setAnchorEl(null);
  }

  const handleBuChange = (val) => {
    dispatch(setBuAction(val))
    props?.onBUChange(val)
    handleBuClose()
  }

  return (
    <Box sx={{
      display: "flex",
      alignItems: "center",
      width: "33%"
    }}>
      <h6 className="fntColor mb-0">{profileState.bu}</h6>
      {
        businessUnitArr.length > 1 &&
        <MdKeyboardArrowDown size={20} style={{ color: "white", cursor: "pointer", margin: 5 }} onClick={handleBuClick} />
      }

      <Popover
        id={BuSelectId}
        open={isBuSelectOpen}
        anchorEl={anchorEl}
        onClose={handleBuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List >
          {businessUnitArr.map(item =>
            <ListItemButton key={item} selected={item === profileState.bu}
              onClick={() => handleBuChange(item)}
              sx={[{
                fontSize: ".9rem",
                padding: "6px 16px"
              },
              {
                '&:hover': {
                  backgroundColor: '#e1fcf5',
                }
              },
              {
                '&.Mui-selected': {
                  backgroundColor: COLORS.green,
                  color: 'white',
                  '&:hover': {
                    backgroundColor: COLORS.green,
                  }
                }
              }
              ]}>
              <ListItemText disableTypography primary={item}
                sx={{ fontSize: ".9rem", padding: 0, margin: 0 }} />
            </ListItemButton>
          )}
        </List>
      </Popover>

    </Box>
  )
}

export default BuSelect







